import { CourseDef } from '../../types';

import { introducaoTecnica } from './courses/introducaoTecnica/_index';
import { priceAction } from './courses/priceAction/_index';
import { padroesDeVelas } from './courses/padroesDeVelas/_index';
import { indicadoresTecnicos } from './courses/indicadoresTecnicos/_index';
import { tradeNaPratica } from './courses/tradeNaPratica/_index';
import { estrategiasDeMercadoAberto } from './courses/estrategiasDeMercadoAberto/_index';
import { masterclassAoVivo } from './courses/masterclassAoVivo/_index';

export const module2Name = '2️⃣ - CONTEÚDOS TÉCNICOS E ESTRATÉGIAS';

// DEPRECATED: conversão temporária substituída pelo array definitivo abaixo

export const module2Courses: CourseDef[] = [
  introducaoTecnica,
  priceAction,
  padroesDeVelas,
  indicadoresTecnicos,
  tradeNaPratica,
  estrategiasDeMercadoAberto,
  masterclassAoVivo,
];

